/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setAppMessagePreference} from '../api'

export const useMutationSetAppMessagePreference = createReactQueryMutationHook('setAppMessagePreference', setAppMessagePreference)
